module.exports = __webpack_public_path__ + "static/media/logo.a497d91a.png";